import { ctaButtons } from "@/utils/constants";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20composition%20of%20diverse%20fashion%20and%20lifestyle%20products%20arranged%20on%20warm%20sand%20colored%20textured%20surface%2C%20sneakers%20at%20center%20surrounded%20by%20folded%20neutral%20garments%2C%20leather%20accessories%2C%20minimalist%20ceramic%20objects%2C%20soft%20diffused%20daylight%20from%20large%20window%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20editorial%20aesthetic%20with%20organic%20arrangement%2C%20gentle%20cast%20shadows%2C%20premium%20ecommerce%20lifestyle%20photography%2C%20european%20minimalism&width=1800&height=1200&seq=kakobuy-hero-v2&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-background-50/90 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
            </span>
            <span className="text-xs md:text-sm text-foreground-800 font-medium whitespace-nowrap">
              Ponad tysiące produktów uporządkowanych według kategorii
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            Kakobuy Spreadsheet Polska –{" "}
            <span className="text-accent-500">Znajdź najlepsze produkty szybciej</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Kompletna baza Kakobuy Spreadsheet dla Polski. Odkrywaj popularne produkty, sprawdzaj kategorie i korzystaj z praktycznych poradników zakupowych.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={ctaButtons[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto bg-accent-500 text-background-50 font-semibold px-8 py-3.5 rounded-full hover:bg-accent-600 transition-all text-sm md:text-base whitespace-nowrap cursor-pointer text-center"
            >
              Przeglądaj Kakobuy Spreadsheet
            </a>
            <a
              href="/artykul/kakobuy-spreadsheet-polska"
              className="w-full sm:w-auto bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 font-semibold px-8 py-3.5 rounded-full hover:bg-background-50/30 transition-all text-sm md:text-base whitespace-nowrap cursor-pointer text-center"
            >
              Sprawdź poradnik bezpieczeństwa
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              "Aktualizowane listy produktów",
              "Poradniki dla Polski",
              "Bezpieczne zakupy",
              "Szczegółowe porównania",
            ].map((badge) => (
              <div key={badge} className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-primary-500 text-xs"></i>
                </span>
                <span className="text-xs md:text-sm text-background-50/90 whitespace-nowrap">
                  {badge}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}